import { CheckboxFilter as CheckboxFilterColumn } from './CheckboxFilter';
import { DropdownFilter as DropdownFilterColoumn } from './DropdownFilter';
import { ComboboxFilter as ComboboxFilterColoumn } from './ComboboxFilter';

export {
  CheckboxFilterColumn as CheckboxFilter,
  DropdownFilterColoumn as DropdownFilter,
  ComboboxFilterColoumn as ComboboxFilter,
};
export enum FilterCombineType {
  OR = 'OR',
  AND = 'AND',
  NOT = 'NOT',
}
export type FilterArrayType = {
  value: string | number | boolean | string[] | number[];
  label: string;
  filterKey: string;
  combineType?:
    | FilterCombineType.AND
    | FilterCombineType.NOT
    | FilterCombineType.OR;
};
